
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from '@/App';
var Buffer = require('buffer/').Buffer
import { BrowserRouter } from "react-router-dom";
import useAliyunPageTracker from '@/utils/uploadAliyunTrack.js';
import '@/assets/css/index.less';
import './index.less';
import ErrorBoundary from './components/ErrorBoundary';
import Modal from 'react-modal';
import 'antd-mobile/es/global'

window.Buffer = window.Buffer || Buffer
if( ENV !== 'prod' || location.search.indexOf('debug') > -1){
    const vConsole = new VConsole();
}
const AppWithTracker = () => {
    // 在这里调用Hook，让它成为应用的“根”Hook
    useAliyunPageTracker();
    return <App />;
};
try {

  const rootElement = document.getElementById('root');

  Modal.setAppElement(rootElement);

  const renderApp = () => {
    ReactDOM.render(
      <React.StrictMode>
          <ErrorBoundary>
                <BrowserRouter>
                  <AppWithTracker />
                </BrowserRouter>
          </ErrorBoundary>
      </React.StrictMode>,
      document.getElementById('root'),
    );
  };
  renderApp();
} catch (e) {
  console.log('e');
}
